import { isBrowser } from '../generic';

export const DEQ_LOADED_EVENT = 'deq-loaded';

export const baseTrackPageView = (pageTemplate: string, pageType?: string) => {
  if (!isBrowser) return;

  if (!window.aabAnalytics) {
    window.addEventListener(DEQ_LOADED_EVENT, () => {
      baseTrackPageView(pageTemplate, pageType);
    });

    return;
  }

  const data: any = {
    page_url: window.location.href,
    page_language: 'nl',
    page_template: pageTemplate, // value stated in CMS
    page_channel: 'open domain', // Linkedin
  };
  if (pageType) {
    data.page_type = pageType;
  }

  window.aabAnalytics.push({
    command: 'ADD EVENT',
    name: 'pageview',
    data,
  });
};
